import React from "react";

import { Box, Typography } from "@material-ui/core";
import { fade, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
    fontSize: "0.82rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  list: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "116px minmax(0, 1fr)",
    gap: theme.spacing(1.25),
    alignItems: "start",
    padding: theme.spacing(1.1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  alertRow: {
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    backgroundColor: fade(theme.palette.error.main, 0.07),
  },
  label: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
  },
  value: {
    minWidth: 0,
    fontSize: "0.82rem",
    fontWeight: 500,
    overflowWrap: "anywhere",
  },
  alertValue: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  description: {
    paddingTop: theme.spacing(2),
  },
  descriptionText: {
    marginTop: theme.spacing(0.75),
    fontSize: "0.82rem",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },
}));

const DealSummary = ({ items, description }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Resumo do negocio</Typography>
      <Box className={classes.list}>
        {items.map((item) => (
          <Box
            key={item.key}
            className={`${classes.row} ${item.alert ? classes.alertRow : ""}`}
          >
            <Typography className={classes.label}>{item.label}</Typography>
            <Box
              className={`${classes.value} ${
                item.alert ? classes.alertValue : ""
              }`}
            >
              {item.value}
            </Box>
          </Box>
        ))}
      </Box>
      <Box className={classes.description}>
        <Typography className={classes.label}>Descricao</Typography>
        <Typography className={classes.descriptionText}>
          {description || "Sem descricao"}
        </Typography>
      </Box>
    </Box>
  );
};

export default DealSummary;
